var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
export const BasicSelect = (props) => {
    const { label, helperText, children, placeholder, error, multiple, renderValue } = props, rest = __rest(props, ["label", "helperText", "children", "placeholder", "error", "multiple", "renderValue"]);
    return (React.createElement("div", null,
        React.createElement(FormControl, { "data-qa": "basicselect-core" },
            label && !placeholder && React.createElement(InputLabel, null, label),
            React.createElement(Select, Object.assign({}, rest, { multiple: multiple, inputProps: { 'aria-label': 'Without label' }, error: error, displayEmpty: true, IconComponent: ExpandMoreIcon, renderValue: multiple
                    ? (selected) => {
                        if (selected.length === 0) {
                            return React.createElement(Typography, null, placeholder);
                        }
                        return renderValue ? renderValue(selected) : selected.join(', ');
                    }
                    : renderValue }), children),
            helperText && React.createElement(FormHelperText, { error: error }, helperText))));
};
